import { CardType } from '../../utils/mapCardType'

export type Card = {
    type: CardType
    token: string
    expired: boolean
    primary: boolean
    expiry: {
        year: string
        month: string
    }
    card_holder: {
        name?: string
        first_name?: string
        last_name?: string
    }
    lastFourDigits: string
    loading?: boolean
    loadError?: boolean
}

export type Wallet = {
    cards?: Array<Card>
    fetching: boolean
    loading?: boolean
    error?: boolean | string
}

export const initWalletState = (): Wallet => ({ cards: undefined, fetching: false, error: false })
